import React from 'react';
import { ChevronRight } from 'react-feather';
import { useIsEnrolledUser, useIsSignedIn } from 'entity/user/userHooks';
import { useSelector } from 'react-redux';
import { RootState } from 'reducer';
import Link from 'components/misc/Link';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import useIsMobile from 'utils/hooks/useIsMobile';
import TierColorContainer from 'components/reward/TierColorContainer';
import NonEnrolledUserDashboard from './NonEnrolledUserDashboard';
import NonSignedInUserDashboard from './NonSignedInUserDashboard';
import EnrolledUserDashboard from './EnrolledUserDashboard';

const RewardCreditCard = () => {
  const profile = useSelector((state: RootState) => state.profile.user);
  const isSignedin = useIsSignedIn();
  const isEnrolled = useIsEnrolledUser();
  const isMobile = useIsMobile();
  const tier = profile?.tier || 1;

  return (
    <div className="w-full pl-4 pr-4 pt-4 lg:p-0">
      <TierColorContainer
        tier={tier}
        className="p-4 rounded-lg w-full h-fit rounded-b-none"
      >
        {!isSignedin && <NonSignedInUserDashboard />}
        {isSignedin && !isEnrolled && (
          <NonEnrolledUserDashboard isInverted={isMobile} />
        )}
        {isEnrolled && <EnrolledUserDashboard />}
      </TierColorContainer>
      <Link href="/rewards/about" passHref>
        <a
          onClick={() => {
            mixpanel.track(trackedEvents.RewardsCollection, {
              param: 'about_tiers_credits',
            });
          }}
        >
          <div className="p-4 rounded-lg w-full h-fit rounded-t-none bg-neutral-100">
            <div className="flex items-center justify-between w-full">
              <p className="text-sm font-semibold">About Tiers & Credits</p>
              <ChevronRight size={20} />
            </div>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default RewardCreditCard;
